import { mapState, mapGetters } from 'vuex'
import { DefaultValues, Document, Quickview, CustomFields } from '@/mixins'
import moment from 'moment'

const emptyContact = ({
  title: null,
  birth_name: null,
  first_name: null,
  last_name: null,
  external_id: null,
  email: null,
  phone: null,
  address: null,
  birthplace: null,
  birthday: null,
  nationality: null,
  family_situation: null,
  matrimonial_status: null,
  wedding_place: null,
  wedding_date: null,
  profession: null,
  csp: null,
  income: null,
  financial_data: {
    is_owner: null,
    land_income: null,
    tax_income: null,
    fiscal_share: null,
    monthly_outcome: null,
    debt: null,
    monthly_saving: null,
    available_capital: null
  },
  children: null,
  children_date: [],
  nature: 'human',
  rgpd_consent: false,
  corporation_name: null,
  customs_fields: null,
  corporation_siret: null,
  wedding_notary_data: {
    name: null,
    city: null
  }
})

export default {
  name: 'ContactMixin',
  mixins: [DefaultValues, Quickview, Document, CustomFields],
  data () {
    return {
      submitLoading: false,
      id: null,
      // set to true in the upper component that call this mixin all children components witch embed this Mixin
      isParent: false,
      loading: false,
      contact: null,
      contactUser: null,
      contactOrigin: null,
      contactPrograms: [],
      contactLoans: [],
      contactSpouse: null,
      contactNotes: [],
      shareIntents: [],
      contactSearches: [],
      contactOptions: [],
      contactRdvs: [],
      contactClaims: [],
      contactReservations: [],
      // set to true if you want to add new spouse (with quickview)
      spouseMode: false,
      stopContactModalContent: null,
      fieldTextPromoteur: `L'arrêt du partage de contact entrainera le retrait du contact de la base de donnée du prescripteur.
        Il n'aura plus accès à la fiche de celui-ci.
        Les options sui lui sont liées seront automatiquement annulées.`,
      fieldText: `L'arrêt du partage du contact entrainera le retrait du contact de votre base de donnée, vous n'aurez plus accès à la fiche de celui-ci. Les options qui lui sont liées seront automatiquement annulées.`,
      duplicateContact: false,
      duplicateDenunciation: false,
      comment: null,
      baseComment: null,
      openComment: true,
      loadComment: false,
      openCommentWysi: null,
      loadOptionComment: false,
      distance: null
    }
  },
  computed: {
    ...mapState(['currentUser', 'quickview', 'savedFilters']),
    ...mapGetters(['isAdmin', 'isManager', 'isOperator', 'isPromoteur', 'plan', 'canUseCalendar', 'canUseContactSharing']),
    c () {
      return this.contact
    },
    // return current element, needed for Document Mixin
    documentEl () {
      return this.contact
    },
    // return method for patch, needed for Document Mixin
    patchElement () {
      return this.patchContactDocument
    },
    contactPk () {
      if (this.c) {
        return this.c.pk
      } else if (this.$route.params.id) {
        return this.$route.params.id
      } else return null
    },
    contactView () {
      return this.$route.name
    },
    isHuman () {
      return this.c.nature && this.c.nature === 'human'
    },
    isCorporation () {
      return this.c.nature && this.c.nature === 'corporation'
    },
    spouse () {
      if (this.c) {
        return this.c.spouse
      }
      return null
    },
    contactTabLinks () {
      let tabs = [
        { link: 'ContactHistory', label: 'Historique' },
        { link: 'ContactInfos', label: 'Informations' },
        { link: 'ContactSearches', label: 'Recherches' },
        { link: 'ContactOptions', label: 'Options' },
        { link: 'ContactReservations', label: 'Achats' }
      ]
      if (this.canUseCalendar) {
        tabs.push({ link: 'ContactRdvs', label: 'Rendez-vous' })
      }
      tabs.push({ link: 'ContactDocuments', label: 'Documents' })
      return tabs
    }
  },
  props: {
    sourceContact: Object,
    sourceContactHistory: {
      type: Array,
      default: () => []
    },
    sourceContactOptions: {
      type: Array,
      default: () => []
    },
    sourceContactRdvs: {
      type: Array,
      default: () => []
    },
    sourceContactSearches: {
      type: Array,
      default: () => []
    },
    sourceContactReservations: {
      type: Array,
      default: () => []
    },
    sourceContactClaims: {
      type: Array,
      default: () => []
    },
    sourceContactNotes: {
      type: Array,
      default: () => []
    },
    sourceLoading: {
      type: Boolean,
      default: false
    },
    fromQuickview: {
      type: Boolean,
      default: false
    },
    newContact: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    sourceLoading (v) {
      this.loading = v
    },
    '$route.params.id' (to, from) {
      if (to && to !== from) {
        this.initView(to)
      }
    }
  },
  created () {
    this.initView()
  },
  methods: {
    createRdv () {
      let params = {
        contact: this.c,
        type: 'rdv'
      }
      this.openCalendarNewAction(params)
    },
    async initView () {
      this.viewId = Math.random().toString(16).slice(2, 8)
      if (this.paramsQuickview && this.paramsQuickview.spouseMode) {
        this.contact = Object.assign({}, this.paramsQuickview.source || emptyContact)
        this.contact.customs_fields = await this.initCustomFields()
      } else if (this.paramsQuickview && this.paramsQuickview.contact) {
        this.contact = Object.assign({}, this.paramsQuickview.contact || emptyContact)
      } else if (this.sourceContact) {
        this.initContact({ ...this.sourceContact })
      } else if (this.$route.params.id && !this.fromQuickview && this.contactView !== 'SaleForm' && this.contactView !== 'PreReservation' && this.contactView !== 'AdvInfos') {
        this.id = this.$route.params.id
        this.getContact(this.id)
      } else if (this.$route.query.spouseMode === true && this.$route.query.parentContactId) {
        // Mode création de conjoint : récupérer les données du parent pour pré-remplir
        await this.initSpouseFromParent(this.$route.query.parentContactId)
      } else {
        emptyContact.customs_fields = await this.initCustomFields()
        emptyContact.wedding_notary_data = { name: null, city: null }
        this.initContact({ ...emptyContact })
      }
      this.getContactItems()
      this.updateSources({
        options: this.sourceContactOptions,
        rdvs: this.sourceContactRdvs,
        reservations: this.sourceContactReservations,
        claims: this.sourceContactClaims,
        searches: this.sourceContactSearches,
        notes: this.sourceContactNotes
      })
    },
    async initCustomFields () {
      const customFields = await this.getCustomFields()
      return customFields.map(customField => {
        return {
          customfieldlink: {
            value: null,
            custom_field_pk: customField,
            custom_field_interface_pk: null
          }
        }
      })
    },
    /**
     * Initialise un nouveau conjoint en récupérant les données familiales du contact parent
     * @param { String } parentContactId - ID du contact parent
     */
    async initSpouseFromParent (parentContactId) {
      this.loading = true
      try {
        // Récupérer les données du contact parent
        const { data: parentContact } = await this.$api.getOne(this.$resources.CONTACT, parentContactId)

        // Créer un nouveau contact vide avec les customs fields
        const newContact = { ...emptyContact }
        newContact.customs_fields = await this.initCustomFields()
        newContact.wedding_notary_data = { name: null, city: null }

        // Reporter les données familiales du parent vers le conjoint
        if (parentContact.family_situation) {
          newContact.family_situation = parentContact.family_situation
        }

        if (parentContact.matrimonial_status) {
          newContact.matrimonial_status = parentContact.matrimonial_status
        }

        if (parentContact.children != null) {
          newContact.children = parentContact.children
        }

        if (parentContact.children_date && parentContact.children_date.length > 0) {
          newContact.children_date = [...parentContact.children_date]
        }

        if (parentContact.wedding_date) {
          newContact.wedding_date = parentContact.wedding_date
        }

        if (parentContact.wedding_place) {
          newContact.wedding_place = parentContact.wedding_place
        }

        if (parentContact.wedding_notary_data) {
          if (parentContact.wedding_notary_data.name) {
            newContact.wedding_notary_data.name = parentContact.wedding_notary_data.name
          }
          if (parentContact.wedding_notary_data.city) {
            newContact.wedding_notary_data.city = parentContact.wedding_notary_data.city
          }
        }

        this.initContact(newContact)
        this.loading = false
      } catch (e) {
        console.error('Erreur lors de la récupération des données du contact parent:', e)
        // En cas d'erreur, initialiser avec un contact vide
        emptyContact.customs_fields = await this.initCustomFields()
        emptyContact.wedding_notary_data = { name: null, city: null }
        this.initContact({ ...emptyContact })
        this.loading = false
      }
    },
    /**
     * Synchronise les enfants entre deux contacts liés (conjoints)
     * @param { Number } contactId - ID du contact source
     * @param { Number } spouseId - ID du conjoint
     * @param { Boolean } isInitialLink - True si c'est le premier lien entre les contacts
     * @returns { Object } - { contactChildren, contactChildrenDates, spouseChildren, spouseChildrenDates }
     */
    async syncChildrenWithSpouse (contactId, spouseId, isInitialLink = false) {
      if (!contactId || !spouseId) {
        return null
      }

      try {
        const { data: contact } = await this.$api.getOne(this.$resources.CONTACT, contactId)
        const { data: spouse } = await this.$api.getOne(this.$resources.CONTACT, spouseId)

        const contactChildren = contact.children || 0
        const spouseChildren = spouse.children || 0
        const contactChildrenDates = Array.isArray(contact.children_date) ? contact.children_date : []
        const spouseChildrenDates = Array.isArray(spouse.children_date) ? spouse.children_date : []

        let finalChildren = 0
        let finalChildrenDates = []

        if (isInitialLink) {
          if (contactChildren > 0 && spouseChildren === 0) {
            finalChildren = contactChildren
            finalChildrenDates = [...contactChildrenDates]
          } else if (contactChildren === 0 && spouseChildren > 0) {
            finalChildren = spouseChildren
            finalChildrenDates = [...spouseChildrenDates]
          } else if (contactChildren > 0 && spouseChildren > 0) {
            finalChildren = contactChildren + spouseChildren
            finalChildrenDates = []
            for (let i = 0; i < contactChildren; i++) {
              finalChildrenDates.push(contactChildrenDates[i] || null)
            }
            for (let i = 0; i < spouseChildren; i++) {
              finalChildrenDates.push(spouseChildrenDates[i] || null)
            }
          }
        } else {
          finalChildren = contactChildren
          finalChildrenDates = [...contactChildrenDates]
        }

        if (finalChildren === 0) {
          finalChildrenDates = []
        } else {
          finalChildrenDates = finalChildrenDates.slice(0, finalChildren)
        }

        const updatePayload = {
          children: finalChildren,
          children_date: finalChildrenDates
        }

        await this.$api.patch(this.$resources.CONTACT, contactId, this.$cleanPayload(updatePayload))
        await this.$api.patch(this.$resources.CONTACT, spouseId, this.$cleanPayload(updatePayload))

        return {
          contactChildren: finalChildren,
          contactChildrenDates: finalChildrenDates,
          spouseChildren: finalChildren,
          spouseChildrenDates: finalChildrenDates
        }
      } catch (e) {
        console.error('Erreur lors de la synchronisation des enfants avec le conjoint:', e)
        this.$toasted.global.danger('Erreur lors de la synchronisation des enfants')
        return null
      }
    },
    async syncFamilyDataWithSpouse (contactData) {
      if (!contactData.spouse || !contactData.spouse.pk) {
        return
      }

      const spouseId = contactData.spouse.pk

      try {
        const { data: spouseData } = await this.$api.getOne(this.$resources.CONTACT, spouseId)

        const dataToSyncToSpouse = {}
        const dataToSyncToContact = {}

        const isEmpty = (value) => {
          if (value === null || value === undefined) return true
          if (Array.isArray(value)) return value.length === 0
          if (typeof value === 'object') {
            return Object.values(value).every(v => v === null || v === undefined)
          }
          return false
        }

        const hasContent = (value) => !isEmpty(value)

        if (hasContent(contactData.family_situation) && isEmpty(spouseData.family_situation)) {
          dataToSyncToSpouse.family_situation = contactData.family_situation
        } else if (isEmpty(contactData.family_situation) && hasContent(spouseData.family_situation)) {
          dataToSyncToContact.family_situation = spouseData.family_situation
        }

        if (hasContent(contactData.matrimonial_status) && isEmpty(spouseData.matrimonial_status)) {
          dataToSyncToSpouse.matrimonial_status = contactData.matrimonial_status
        } else if (isEmpty(contactData.matrimonial_status) && hasContent(spouseData.matrimonial_status)) {
          dataToSyncToContact.matrimonial_status = spouseData.matrimonial_status
        }

        if (hasContent(contactData.wedding_date) && isEmpty(spouseData.wedding_date)) {
          dataToSyncToSpouse.wedding_date = contactData.wedding_date
        } else if (isEmpty(contactData.wedding_date) && hasContent(spouseData.wedding_date)) {
          dataToSyncToContact.wedding_date = spouseData.wedding_date
        }

        if (hasContent(contactData.wedding_place) && isEmpty(spouseData.wedding_place)) {
          dataToSyncToSpouse.wedding_place = contactData.wedding_place
        } else if (isEmpty(contactData.wedding_place) && hasContent(spouseData.wedding_place)) {
          dataToSyncToContact.wedding_place = spouseData.wedding_place
        }

        if (hasContent(contactData.wedding_notary_data) && isEmpty(spouseData.wedding_notary_data)) {
          dataToSyncToSpouse.wedding_notary_data = contactData.wedding_notary_data
        } else if (isEmpty(contactData.wedding_notary_data) && hasContent(spouseData.wedding_notary_data)) {
          dataToSyncToContact.wedding_notary_data = spouseData.wedding_notary_data
        }

        if (Object.keys(dataToSyncToSpouse).length > 0) {
          await this.$api.patch(this.$resources.CONTACT, spouseId, this.$cleanPayload(dataToSyncToSpouse))
        }

        if (Object.keys(dataToSyncToContact).length > 0) {
          await this.$api.patch(this.$resources.CONTACT, contactData.pk, this.$cleanPayload(dataToSyncToContact))
          Object.assign(this.contact, dataToSyncToContact)
          Object.assign(contactData, dataToSyncToContact)
        }
      } catch (e) {
        console.error('Erreur lors de la synchronisation avec le conjoint:', e)
      }
    },
    /** Get and set contentful modal message. The message is different for admin promoters and for prescribers */
    async getStopContactModalContent (contact) {
      // let contentFullId
      if (contact && contact.user && contact.user.account && contact.user.account.account_type === this.currentUser.account.account_type) {
        // contentFullId = '7wQoifYWGpkATgdWqGIbiy'
        this.stopContactModalContent = this.fieldText
      } else {
        this.stopContactModalContent = this.fieldTextPromoteur
        // contentFullId = '18IzmvUoILaeWLwKj3ucm0'
      }
      // const entry = await this.$contentful.getEntry(contentFullId)
      // this.stopContactModalContent = entry.fields.text
    },
    openUserSelection (type = 'multiple') {
      let params = {
        facets: {
          USER: []
        },
        selectType: type,
        mode: 'store'
      }
      if (this.contact.user) {
        params.facets.USER.push([`pk:-${this.contact.user.pk}`])
      }
      this.openUserSelectionQuickview(params)
    },
    openContactSelection (type = 'multiple') {
      let params = {
        facets: {
          CONTACT: [
            [`pk:-${this.contactPk}`],
            ['spouse:null']
          ]
        },
        selectType: type,
        mode: 'store'
      }
      this.openContactSelectionQuickview({ params })
    },
    initContact (contact) {
      this.$set(this, 'contact', contact)
      this.contactUser = this.contact.user
      this.contactOrigin = this.contact.origin
      if (this.contact.programs && this.contact.programs.length != null) {
        this.contactPrograms = this.contact.programs
      }
      this.contactLoans = this.contact.financial_data ? this.contact.financial_data.loans : []
      if (this.contact.spouse && !this.contactSpouse) this.getContact(this.contact.spouse.pk, true)
    },
    /**
     * @param { Object } contact - pass current contact before api call
     * @returns { Object } - return updated contact prepared for api call
     */
    beforeSubmit (contact) {
      let newContact = { ...contact }
      newContact.financial_data.loans = this.contactLoans
      newContact.origin = this.contactOrigin
      if (newContact.programs && newContact.programs.length) {
        newContact.programs = newContact.programs
          .map(p => (p && typeof p === 'object') ? p.pk : p)
          .filter(p => p)
      } else newContact.programs = []
      if (newContact.original_program) {
        newContact.original_program = (typeof newContact.original_program === 'object')
          ? newContact.original_program.pk
          : newContact.original_program
      } else newContact.original_program = null
      newContact.user = this.contactUser
      newContact.birthday = moment(contact.birthday).set('hour', 12).toISOString()
      newContact.spouse = this.contactSpouse && this.contactSpouse.pk ? this.contactSpouse.pk : this.contactSpouse
      return newContact
    },
    /**
     * get all contact items
     */
    getContactItems () {
      if (!this.contactNotes.length) {
        this.getContactNotes()
      }
      if (!this.contactClaims.length) {
        this.getContactClaims()
      }
      if (this.contactView === 'ContactSearches' && !this.contactSearches.length) {
        this.getContactSearches()
      }
      if ((this.contactView === 'ContactOptions' || this.contactView === 'ContactHistory') && !this.contactOptions.length) {
        this.getContactOptions()
      }
      if ((this.contactView === 'ContactReservations' || this.contactView === 'ContactHistory') && !this.contactReservations.length) {
        this.getContactReservations()
      }

      // subscribe to recall getContactRdvs after currentUser is stored : fix to lost contact history when refreshing page
      const unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'storeCurrentAccount') {
          if ((this.contactView === 'ContactRdvs' || this.contactView === 'ContactHistory') && !this.contactRdvs.length && this.canUseCalendar) {
            this.getContactRdvs()
            unsubscribe()
          }
        }
      })
      if ((this.contactView === 'ContactRdvs' || this.contactView === 'ContactHistory') && !this.contactRdvs.length && this.canUseCalendar) {
        this.getContactRdvs()
      }
      if (this.contactView === 'ContactHistory' && !this.shareIntents.length && this.canUseContactSharing) {
        this.getContactSharingProposals()
      }
    },
    /**
     * @param { Object } - pass all values to emit to all child/parents components
     */
    updateSources ({ options = null, rdvs = null, reservations = null, claims = null, searches = null, notes = null, shareIntents = null }) {
      if (options !== null) this.contactOptions = options
      if (rdvs !== null) this.contactRdvs = rdvs
      if (reservations !== null) this.contactReservations = reservations
      if (claims !== null) this.contactClaims = claims
      if (searches !== null) this.contactSearches = searches
      if (notes !== null) this.contactNotes = notes
      if (shareIntents !== null) this.shareIntents = shareIntents
      if (!this.isParent) {
        this.$emit('updateSources', { options, rdvs, reservations, claims, searches, notes })
      }
    },
    /**
     * @param { String } id - id of contact to get
     * @param { Boolean } spouse - need to be true to edit spouse
     */
    async getContact (id, spouse = false) {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.CONTACT, id)
        if (spouse) {
          this.contactSpouse = data
          this.c.spouse = data
        } else {
          this.initContact(data)
        }
        this.getStopContactModalContent(data)
        this.loading = false
      } catch (e) {
        if (!spouse) {
          this.$router.replace({ name: 'NotFound' })
        }
        this.loading = false
      }
    },
    /**
     * @param { Object } contact - contact to create
     * if in spouseMode and data from quickview, patch current contact to add its spouse
     */
    async createContact (contact) {
      let contactUser = null
      if (contact.user) {
        contactUser = contact.user.pk
      } else {
        contactUser = this.currentUser.pk
      }
      let payload = {
        contact: this.$cleanPayload(contact),
        user: contactUser
      }
      let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
      if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
        data.duplicates.length !== 0 ? contact.doublon_denunciation = true : contact.doublon_denunciation = false
        data.all_pk_contact.length !== 0 ? contact.doublon_contact = true : contact.doublon_contact = false
        // contact.doublon = true
      }
      try {
        let { data } = await this.$api.post(this.$resources.CONTACT, this.$cleanPayload(contact))
        data = data.json_data
        this.submitLoading = false
        const isSpouseCreationFromRoute = this.$route.query.spouseMode === true && this.$route.query.parentContactId
        if (this.spouseMode) {
          this.$toasted.global.success('Conjoint ajouté')
          this.spouseMode = false
          this.c.spouse = data
          this.patchContact(this.c, { spouse: data }, true, true)
        } else if (isSpouseCreationFromRoute) {
          const parentContactId = this.$route.query.parentContactId
          const returnTo = this.$route.query.returnTo || 'ContactInfos'
          this.$toasted.global.success('Conjoint créé avec succès')
          try {
            await this.$api.patch(this.$resources.CONTACT, parentContactId, { spouse: data.pk })
            await this.$api.patch(this.$resources.CONTACT, data.pk, { spouse: parentContactId })
            this.$router.push({ name: returnTo, params: { id: parentContactId } })
          } catch (e) {
            console.log('Error linking spouse to parent contact:', e)
            this.$toasted.global.warning('Le conjoint a été créé mais n\'a pas pu être lié au contact parent')
            this.$router.push({ name: 'ContactInfos', params: { id: data.pk } })
          }
        } else {
          this.$toasted.global.success('Contact ajouté')
          this.$router.replace({ name: 'ContactInfos', params: { id: data.pk } })
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        }
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object } contact - contact to update
     * @param { Boolean } redirectToSpouse - pass id of spouse
     */
    async updateContact (contact, redirectToSpouse = null) {
      let contactUser = null
      if (contact.user) {
        contactUser = contact.user.pk
      } else {
        contactUser = this.currentUser.pk
      }
      let payload = {
        contact: this.$cleanPayload(contact),
        user: contactUser
      }
      let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
      if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
        contact.doublon = true
      }
      this.submitLoading = true
      try {
        const cleanContact = this.$cleanPayload(contact)
        let { data } = await this.$api.put(this.$resources.CONTACT, contact.pk, cleanContact)

        if (data.spouse && data.spouse.pk) {
          await this.syncChildrenWithSpouse(data.pk, data.spouse.pk, false)
          const refreshedContact = await this.$api.getOne(this.$resources.CONTACT, data.pk)
          data = refreshedContact.data
        }

        this.submitLoading = false
        this.$toasted.global.success('Contact modifié')
        if (redirectToSpouse) {
          this.$router.push({ name: 'ContactEdit', params: { id: redirectToSpouse } }).catch(() => {})
        } else {
          this.initContact(data)
          this.$store.commit('setReservationSubmitButtons', true)
          this.$router.goBack()
        }
      } catch (e) {
        console.log(e)
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object } contact - contact to patch
     * @param { Object } newVal - new values to edit in current contact
     * @param { Boolean } background - for background update, avoid router.push and toast
     * @param { Boolean } spouseMode - for patch and keep current data in current contact after change/create spouse
     */
    async patchContact (contact, newVal, background = false, spouseMode) {
      if (!background) this.submitLoading = true
      try {
        let { data } = await this.$api.patch(this.$resources.CONTACT, contact.pk, this.$cleanPayload(newVal))

        if (newVal.spouse) {
          await this.syncFamilyDataWithSpouse(data)

          const spouseId = typeof newVal.spouse === 'object' ? newVal.spouse.pk : newVal.spouse
          const syncResult = await this.syncChildrenWithSpouse(data.pk, spouseId, true)

          if (syncResult) {
            data.children = syncResult.contactChildren
            data.children_date = syncResult.contactChildrenDates
          }
        } else if (data.spouse && data.spouse.pk && (newVal.children !== undefined || newVal.children_date !== undefined)) {
          await this.syncChildrenWithSpouse(data.pk, data.spouse.pk, false)

          const refreshedContact = await this.$api.getOne(this.$resources.CONTACT, data.pk)
          data = refreshedContact.data
        }

        if (!background) {
          this.submitLoading = false
          this.$toasted.global.success('Contact modifié')
        }
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        if (this.$route.name !== 'ContactHistory' && !background) {
          this.$router.push({ name: 'ContactHistory', params: { id: data.pk } })
        }
        // if in spouseMode, merge current contact with contact from api
        if (spouseMode) {
          this.initContact(Object.assign(data, this.c))
        } else {
          this.initContact(data)
        }
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object } contact - contact to delete
     */
    deleteContact (contact) {
      this.$swal({
        title: 'Suppression contact',
        text: 'La suppression du contact entrainera l\'annulation des dénonciations qui lui sont liées. Attention, si le contact à des options ou des ventes en cours, la suppression ne sera pas possible. Vous devrez préalablement annuler les options et ventes en cours.',
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      }).then(async value => {
        if (value && value.dismiss) {
        } else if (value) {
          this.loading = true
          try {
            await this.$api.delete(this.$resources.CONTACT, contact.pk)
            this.loading = false
            this.$toasted.global.success('Contact supprimé')
            this.$router.push({ name: 'ContactList' })
          } catch (e) {
            this.loading = false
            this.$toasted.global.danger('Erreur lors de la suppression !')
          }
        }
      })
    },
    async getContactNotes () {
      if (!this.contactPk) return
      let params = {}
      try {
        let { data } = await this.$api.get(this.$resources.CONTACT_NOTE(this.contactPk), params)
        this.updateSources({ notes: data.items })
      } catch (e) {
      }
    },
    async getContactReservations () {
      let params = {
        co_buyer: this.contactPk
      }
      try {
        let { data } = await this.$api.get(this.$resources.RESERVATION, params)
        this.updateSources({ reservations: data.items })
      } catch (e) {
      }
    },
    async getContactClaims () {
      let params = {
        contact: this.contactPk
      }
      try {
        let { data } = await this.$api.get(this.$resources.CLAIM, params)
        this.updateSources({ claims: data.items })
      } catch (e) {
      }
    },
    async getContactOptions () {
      let params = {
        contact: this.contactPk
      }
      try {
        let { data } = await this.$api.get(this.$resources.OPTION, params)
        this.updateSources({ options: data.items })
      } catch (e) {
      }
    },
    async getContactSearches () {
      if (!this.contactPk) return
      let params = {}
      try {
        let { data } = await this.$api.get(this.$resources.CONTACT_RESEARCH(this.contactPk), params)
        this.updateSources({ searches: data.items })
      } catch (e) {
      }
    },
    async getContactRdvs () {
      let params = {
        contact: this.contactPk
      }
      try {
        let { data } = await this.$api.get(this.$resources.RDV, params)
        this.updateSources({ rdvs: data.items })
      } catch (e) {
      }
    },
    async getContactSharingProposals () {
      let params = {
        contact: this.contactPk
      }
      try {
        let { data } = await this.$api.get(this.$resources.SHARE_INTENT, params)
        this.updateSources({ shareIntents: data.items })
      } catch (e) {
      }
    },
    patchContactDocument (document) {
      this.patchContact(this.c, document, true)
    }
  }
}
